<template>
    <div class="modal-invoice">
        <SOSlotModal :modal-title="modalTitle" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="p-t-16">
                    <div class="f-16">
                        <label for="">Tolak permintaan pembatalan invoice ini?</label>
                    </div>
                    <div class="m-d-16">
                        <SOInputRegular
                            id="input-alasan"
                            title="Alasan"
                            placeholder="Alasan...."
                            :value="posted.alasan"
                            autocomplete="off"
                            :required="true"
                            @input="onChangeInput"
                        />
                        <ErrorMessage class="error" label="Alasan" :validation="$v.posted.alasan" />
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div class="">
                    <SOButton
                        :outline="true"
                        :full="true"
                        :text="'Tolak'"
                        :id="`tolak-pembatalan`"
                        @action="doTolak"
                        :disable="isFetching"
                        :loading="isFetching"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputRegular from "@/so-components/global/input/SOInputRegular.vue";

import ErrorMessage from "@/component-items/ErrorMessage";

import { required } from "vuelidate/lib/validators";

import { moduleName } from "../../store/state";

export default {
    name: "TolakPermintaan",
    components: {
        SOSlotModal,
        SOButton,
        SOInputRegular,
        ErrorMessage,
    },
    data() {
        return {
            modalId: "tolak-pembatalan",
            modalTitle: "Tolak Pembatalan Invoice",
            posted: {
                alasan: "",
            },
            allowSave: false,
            page: {
                loading: false,
            },
            isNotification: false,
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
        this.isNotification = this.$route.params.isNotification
    },
    validations: {
        posted: {
            alasan: {
                required,
            },
        },
    },
    computed: {
        getData() {
            return this.$route.query.data;
        },
        isFetching() {
            return this.page.loading;
        },
        getInvoiceId() {
            return this.$route.params.invoiceId;
        },
    },
    methods: {
        ...mapActions({
            cancelInvoice: `${moduleName}/cancelInvoice`,
            getDetailInvoice: `${moduleName}/getDetailInvoice`,
        }),
        async back(idx = -1) {
            await this.$router.go(idx);
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        onChangeInput(val) {
            this.posted.alasan = val;
        },
        validation() {
            let { alasan } = this.$v.posted;
            alasan.$touch();

            return alasan.$invalid;
        },
        setFetching(val) {
            this.page.loading = val;
        },
        doTolak() {
            if (this.validation()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }
            if (this.isFetching) {
                return;
            }
            let {
                posted: { alasan },
                getInvoiceId,
            } = this;
            this.setFetching(true);
            this.cancelInvoice({
                idinvoice: getInvoiceId,
                catatan: alasan,
                setujui: 0,
            })
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { code, data, status, msg } = res.data;
                        if (code === 200 && status) {
                            this.getDetailInvoice({ invoiceId: getInvoiceId });
                            this.$toast.success(msg);
                            this.setFetching(false);
                            if (this.isNotification) {
                  this.flutterNavigate("dashboard/notification");
                  return;
                            }
                            this.$router.go(-2);
                        } else {
                            this.$toast.error(msg);
                            this.setFetching(false);
                        }
                    }
                })
                .catch((e) => {
                    this.$toast.error(e);
                    this.setFetching(false);
                });
        },
    },
};
</script>
<style scoped src="../../static/style.css"></style>
